import { useEffect } from "react";

import { useGetMarketsByEventIdQuery } from "~/feature/dashboard/dashboardApi";
import type { IGetMarketsByEventIdRequestParams } from "~/feature/dashboard/types";
import { handleError } from "~/utils/handleError";

export const useEventMarkets = (props: IGetMarketsByEventIdRequestParams) => {
  const { data, isLoading, isFetching, error } =
    useGetMarketsByEventIdQuery(props);

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error]);

  return { data, isLoading: isLoading || isFetching };
};
